import { ArrowUpRight, Users, Gauge, Coins } from "lucide-react";

const pillars = [
  {
    id: "begleitung",
    href: "#begleitung",
    n: "01",
    icon: Users,
    partner: "MHorgasConsult",
    title: "Begleitung von Vertriebs- & Führungs­mannschaften",
    body: "Coaching, Trainings und Workshops für Firmen­kunden­berater, Leasing-Vertrieb, Spezialisten und Führungs­kräfte in Banken, Sparkassen und Leasing­gesellschaften.",
  },
  {
    id: "pay-per-use",
    href: "#pay-per-use",
    n: "02",
    icon: Gauge,
    partner: "Repräsentant · Linxfour (Wien)",
    title: "Pay-per-Use · Spezial­finanzierung",
    body: "Nutzungs­basierte Investitions­finanzierung als neue Lösung für den Mittel­stand — über Firmen­kunden­berater oder direkt an das Unternehmen.",
  },
  {
    id: "foerdermittel",
    href: "#foerdermittel",
    n: "03",
    icon: Coins,
    partner: "Repräsentant · REM Capital AG (Stuttgart)",
    title: "Förder­mittel & Zuschüsse",
    body: "Für investierende Unternehmen: öffentliche Förder­mittel und Zuschüsse strukturiert identifizieren, beantragen und realisieren — honoriert auf Erfolgs­basis.",
  },
];

export default function PillarsOverview() {
  return (
    <section
      id="saeulen"
      data-testid="pillars-section"
      className="section-padding bg-[#F9F9FB] border-b border-black/10"
    >
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 mb-12 md:mb-20 items-end">
          <div className="lg:col-span-7">
            <div className="overline mb-4">Drei Säulen</div>
            <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl tracking-tight leading-[1.05]">
              Suchen. Finden.
              <br />
              <span className="text-[#D30000]">Umsetzen.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base md:text-lg leading-relaxed text-[#4A4A52]">
              Als unabhängiger Begleiter bringe ich zusammen, was eine
              Ausrüstungs­investition wirklich braucht: die richtigen
              Menschen, die passende Finanzierungs­form und die vorhandenen
              öffentlichen Mittel.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-[1px] bg-black/10 border border-black/10">
          {pillars.map((p) => (
            <a
              key={p.id}
              href={p.href}
              data-testid={`pillar-card-${p.id}`}
              className="bg-white p-8 md:p-10 flex flex-col group transition-colors duration-200 hover:bg-[#0A0A0A] hover:text-white"
            >
              <div className="flex items-start justify-between mb-10">
                <div className="w-12 h-12 border border-current flex items-center justify-center">
                  <p.icon size={20} strokeWidth={1.5} />
                </div>
                <span className="text-xs font-mono opacity-50">{p.n}</span>
              </div>

              <div className="text-xs uppercase tracking-[0.2em] opacity-70 mb-4">
                {p.partner}
              </div>

              <h3 className="font-display font-bold text-xl md:text-2xl tracking-tight leading-[1.15]">
                {p.title}
              </h3>

              <p className="mt-5 text-sm md:text-base leading-relaxed opacity-80 flex-1">
                {p.body}
              </p>

              <div className="mt-8 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] hover-marker w-fit">
                Mehr erfahren <ArrowUpRight size={14} />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
